// @core/api/endpoints/subscription/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CancelBundleSubscription } from './cancel_bundle_subscription';
import { CancelTenantSubscription } from './cancel_tenant_subscription';
import { CheckEntitlement } from './check_entitlement';
import { CreateAddOn } from './create_add_on';
import { CreateDiscount } from './create_discount';
import { CreateFeatureUsageRecord } from './create_feature_usage_record';
import { CreatePlan } from './create_plan';
import { CreateProductBundle } from './create_product_bundle';
import { CreateSubscription } from './create_subscription';
import { CreateSubscriptionItem } from './create_subscription_item';
import { DeleteAddOn } from './delete_add_on';
import { DeleteDiscount } from './delete_discount';
import { DeletePlan } from './delete_plan';
import { DeleteProductBundle } from './delete_product_bundle';
import { DeleteSubscription } from './delete_subscription';
import { DeleteSubscriptionItem } from './delete_subscription_item';
import { GetAddOn } from './get_add_on';
import { GetBundleSubscription } from './get_bundle_subscription';
import { GetBundleSubscriptionPreview } from './get_bundle_subscription_preview';
import { GetDiscount } from './get_discount';
import { GetEntitlement } from './get_entitlement';
import { GetFeatureUsage } from './get_feature_usage';
import { GetPlan } from './get_plan';
import { GetProductBundle } from './get_product_bundle';
import { GetSubscription } from './get_subscription';
import { GetSubscriptionAnalytics } from './get_subscription_analytics';
import { GetSubscriptionItem } from './get_subscription_item';
import { GetSubscriptionPlanChangePreview } from './get_subscription_plan_change_preview';
import { GetTenantSubscription } from './get_tenant_subscription';
import { ListAddOns } from './list_add_ons';
import { ListBundleSubscriptions } from './list_bundle_subscriptions';
import { ListDiscounts } from './list_discounts';
import { ListEntitlements } from './list_entitlements';
import { ListPlans } from './list_plans';
import { ListProductBundles } from './list_product_bundles';
import { ListSubscriptionItems } from './list_subscription_items';
import { ListSubscriptions } from './list_subscriptions';
import { ListTenantSubscriptions } from './list_tenant_subscriptions';
import { PurchaseAddOn } from './purchase_add_on';
import { SetSubscriptionCancel } from './set_subscription_cancel';
import { SetSubscriptionPause } from './set_subscription_pause';
import { SetSubscriptionPlanChange } from './set_subscription_plan_change';
import { SetSubscriptionResume } from './set_subscription_resume';
import { SubscribeTenant } from './subscribe_tenant';
import { SubscribeToBundle } from './subscribe_to_bundle';
import { UpdateAddOn } from './update_add_on';
import { UpdateDiscount } from './update_discount';
import { UpdatePlan } from './update_plan';
import { UpdateProductBundle } from './update_product_bundle';
import { UpdateSubscription } from './update_subscription';
import { UpdateSubscriptionItem } from './update_subscription_item';
import { UpdateTenantSubscription } from './update_tenant_subscription';
import { ValidateDiscount } from './validate_discount';

// Re-export individual endpoints
export {
  CancelBundleSubscription,
  CancelTenantSubscription,
  CheckEntitlement,
  CreateAddOn,
  CreateDiscount,
  CreateFeatureUsageRecord,
  CreatePlan,
  CreateProductBundle,
  CreateSubscription,
  CreateSubscriptionItem,
  DeleteAddOn,
  DeleteDiscount,
  DeletePlan,
  DeleteProductBundle,
  DeleteSubscription,
  DeleteSubscriptionItem,
  GetAddOn,
  GetBundleSubscription,
  GetBundleSubscriptionPreview,
  GetDiscount,
  GetEntitlement,
  GetFeatureUsage,
  GetPlan,
  GetProductBundle,
  GetSubscription,
  GetSubscriptionAnalytics,
  GetSubscriptionItem,
  GetSubscriptionPlanChangePreview,
  GetTenantSubscription,
  ListAddOns,
  ListBundleSubscriptions,
  ListDiscounts,
  ListEntitlements,
  ListPlans,
  ListProductBundles,
  ListSubscriptionItems,
  ListSubscriptions,
  ListTenantSubscriptions,
  PurchaseAddOn,
  SetSubscriptionCancel,
  SetSubscriptionPause,
  SetSubscriptionPlanChange,
  SetSubscriptionResume,
  SubscribeTenant,
  SubscribeToBundle,
  UpdateAddOn,
  UpdateDiscount,
  UpdatePlan,
  UpdateProductBundle,
  UpdateSubscription,
  UpdateSubscriptionItem,
  UpdateTenantSubscription,
  ValidateDiscount,
};

// Namespace export for convenient usage
export const subscriptionApi = {
  CancelBundleSubscription,
  CancelTenantSubscription,
  CheckEntitlement,
  CreateAddOn,
  CreateDiscount,
  CreateFeatureUsageRecord,
  CreatePlan,
  CreateProductBundle,
  CreateSubscription,
  CreateSubscriptionItem,
  DeleteAddOn,
  DeleteDiscount,
  DeletePlan,
  DeleteProductBundle,
  DeleteSubscription,
  DeleteSubscriptionItem,
  GetAddOn,
  GetBundleSubscription,
  GetBundleSubscriptionPreview,
  GetDiscount,
  GetEntitlement,
  GetFeatureUsage,
  GetPlan,
  GetProductBundle,
  GetSubscription,
  GetSubscriptionAnalytics,
  GetSubscriptionItem,
  GetSubscriptionPlanChangePreview,
  GetTenantSubscription,
  ListAddOns,
  ListBundleSubscriptions,
  ListDiscounts,
  ListEntitlements,
  ListPlans,
  ListProductBundles,
  ListSubscriptionItems,
  ListSubscriptions,
  ListTenantSubscriptions,
  PurchaseAddOn,
  SetSubscriptionCancel,
  SetSubscriptionPause,
  SetSubscriptionPlanChange,
  SetSubscriptionResume,
  SubscribeTenant,
  SubscribeToBundle,
  UpdateAddOn,
  UpdateDiscount,
  UpdatePlan,
  UpdateProductBundle,
  UpdateSubscription,
  UpdateSubscriptionItem,
  UpdateTenantSubscription,
  ValidateDiscount,
};
